import ChatInput from '../ChatInput/ChatInput.jsx';

/**
 * Empty chat panel — centered title + composer (no agent selected).
 * @param {object} props
 * @param {string} [props.title]
 * @param {string} [props.className]
 * @param {object} props.chatInputProps — forwarded to {@link ChatInput}
 */
const ChatPanelEmptyState = ({
  title = 'How can I help you today?',
  className = '',
  aboveComposerSlot = null,
  chatInputProps,
}) => {
  const { composerMountKey = 0, ...chatInputRest } = chatInputProps ?? {};
  return (
    <div className={`flex min-h-0 flex-1 flex-col ${className}`.trim()}>
      <div className="flex min-h-0 flex-1 flex-col items-center justify-center gap-6 px-2 py-6 text-center">
        <h2 className="text-lg font-semibold text-content">{title}</h2>
        <div className="w-full max-w-2xl shrink-0">
          {aboveComposerSlot ? (
            <div className="scrollbar-aimsos-auto mb-2 max-h-[45vh] min-w-0 overflow-y-auto text-left">
              {aboveComposerSlot}
            </div>
          ) : null}
          <ChatInput
            key={composerMountKey}
            className="w-full min-w-0"
            growDirection="up"
            {...chatInputRest}
          />
        </div>
      </div>
    </div>
  );
};

export default ChatPanelEmptyState;
